import { Component } from '@angular/core';

@Component({
    selector: 'bb-account-number-pipe-page-ui',
    template: '',
    styles: [],
    standalone: false,
})
export class AccountNumberPipePageComponent {}
